import { Divider } from "@mui/material";
import { Link } from "react-router";

import {
  RobotoStyledTab,
  RobotoStyledTabs,
} from "@/shared/components/RobotoStyledTabs";
import { useCheckFeatureFlag } from "@/shared/domain/featureFlags/hooks";
import { Goto } from "@/shared/navigation";

import styles from "./DevicesTabs.module.css";

const DEVICES_TABS = [
  { tab: "devices", label: "Devices", to: Goto.route.Devices },
  { tab: "device-types", label: "Device Types", to: Goto.route.DeviceTypes },
] as const;

interface DevicesTabsProps {
  /** The tab of the page that renders this tab strip. */
  activeTab: (typeof DEVICES_TABS)[number]["tab"];
}

/**
 * Tab strip of the Devices pages: the devices list and the device types list,
 * each at its own top-level URL (`/devices/<segment>` is a device whose ID is
 * that segment, so the types list cannot sit under `/devices`). Renders
 * nothing unless `release-asset-store` is on for the org: with the flag off,
 * the device types URL redirects to the devices list, so there is no second
 * tab to switch to.
 */
export function DevicesTabs({ activeTab }: DevicesTabsProps) {
  const deviceTypesEnabled = useCheckFeatureFlag("release-asset-store");

  if (!deviceTypesEnabled) {
    return null;
  }

  return (
    <div className={styles.tabs}>
      <RobotoStyledTabs value={activeTab} aria-label="Devices">
        {DEVICES_TABS.map(({ tab, label, to }) => (
          <RobotoStyledTab
            key={tab}
            value={tab}
            label={label}
            component={Link}
            to={to}
          />
        ))}
      </RobotoStyledTabs>
      <Divider />
    </div>
  );
}
